import React, { Component } from 'react'
import SliderDetail from '../../../../containers/Sections/Propiedades/sliderDetail'
import SliderHome from '../../../Slider'
import SliderFixed from '../../../Slider/fixed'
import SliderHomeResponsive from '../../../Slider/responsive'
import SliderNeighborhood from './Slider/sliderNeighborhood'
import { Button, Popover, OverlayTrigger, Col } from 'react-bootstrap'
import Maps from '../../../../containers/Sections/Propiedades/detailMap'
import StreetViewMaps from '../../../Maps/streetView'
import { ShareButtons, generateShareIcon } from 'react-share'
import Spinner from '../../../Spinner'
import HeaderInfo from './header'
import Description from './description'
import ColumnsInfo from './caracteristicsColumns'
import StickyMenu from './stickyMenu'
import Neighbordhood from './neighbordhood'
import FormContact  from './form'
import { translate } from 'react-translate'

@translate('PropertyDetail')
class PropertyDetail extends Component{

  constructor (props) {
    super(props)

    this.state = {
      modal: false,
      property: 0,
      showInfo: false
    }
    this.changeView = this.changeView.bind(this)
    this.toggle = this.toggle.bind(this)
  }

  changeView() {
    this.setState({modal: !this.state.modal })
  }

  toggle() {
    this.setState({showInfo: !this.state.showInfo })
    window.scrollTo(0, 0)
  }

  getStateFromStore(props) {
    const { id } = props.params.id
    return {
      property: id
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount(){
    window.scrollTo(0, 0)
    this.props.loadPropertyDetails(this.props.params.id)
    this.props.findCategories()
    this.props.findterrainUses()
    this.props.findUbications()
  }

  handleChangeProperty(code) {
    this.props.loadPropertyDetails(code)
    window.scrollTo(0, 0)
  }

  render(){

    const {
      property, onChangeInfoType, infoType, loading, related, neighborhoodDetail,
      onChangePanelProfile, officeCategories, terrainUses, ubications,
      siblings, t, checkStreetViewStatus, streetView, originPath, originOffice, phone,
    } = this.props

   let telephone = 'tel:+5411' + phone.replace('-', '')

    if (loading){
      return (
        <Spinner />
      )
    } else{
      if (!property) {
        return (
          <div className='col-md-12 col-error'>
            <div className='no-properties-box'>
              <i className='fa fa-exclamation-circle' aria-hidden='true'></i>
              <p>Error al cargar la propiedad, inténtelo nuevamente.</p>
            </div>
          </div>
        )
      }
      else{
        let neighborhood = property.neighborhood ? (property.neighborhood.name).toLowerCase() : ''
        let location = property.short_address
        let dir = property.address
        let divisa_rental = property.rental_currency.name
        let divisa_sale = property.sale_currency.name
        if (property.rental_currency.name == 'Dolar') {
          divisa_rental = 'u$s'
        }
        if (property.sale_currency.name == 'Dolar') {
          divisa_sale = 'u$s'
        }
        let amount = (property.operation_type && (property.operation_type.name === 'Alquiler' || property.operation_type.name == 'Alquiler temporario')) ?
          divisa_rental + ' ' + (parseInt(property.rental_amount)).toLocaleString('de-DE') : divisa_sale + ' ' + (parseInt(property.sale_amount)).toLocaleString('de-DE')
        let price

        if((property.category_type_id === 9 || !property.web_price) ||
          ((property.operation_type.name == 'Alquiler' || property.operation_type.name == 'Alquiler temporario') && (property.rental_amount in [0, 1, null, undefined, ''])) ||
          ((property.operation_type.name == 'Venta' || property.operation_type.name == 'Venta/Alquiler') && (property.sale_amount in [0, 1, null, undefined, '']))) {
          price = t('Consultar_precio')
        } else {
          price = amount
        }

        let operationName
        if (property.operation_type.name == 'Venta/Alquiler'){
          operationName = `${t('Venta')} / ${t('Alquiler')}`
        }
        else{
          operationName = t(property.operation_type.name)
        }

        let mainClass = (infoType === 'info') ? 'main-property-info' : 'main-property-info' + ' ' + 'hidden-xs'
        let mapClass = (infoType === 'map') ? 'main-property-map' : 'main-property-map' + ' ' + 'hide'
        let hideInfoContent = (infoType === 'info') ? '' : 'hidden-xs'
        let hideNoNeighbord = (property.neighborhood) ? '' : 'hidden'

        let mapsContent = ''
        let baseUrl = window.location.origin
        let shareUrl = baseUrl + '/' + property.uri
        let sliderClass = (property.images || property.image) ? ' slider-container slider-detail ' : 'slider-container slider-detail hidden'

        const { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } = ShareButtons

        const FacebookIcon = generateShareIcon('facebook')
        const TwitterIcon = generateShareIcon('twitter')
        const LinkedinIcon = generateShareIcon('linkedin')
        const WhatsappIcon = generateShareIcon('whatsapp')

        const title = 'LJ Ramos'

        const popoverShare = (
          <Popover id='popover-share'>
            <WhatsappShareButton
              url={shareUrl}
              title={title}>
              <WhatsappIcon
                size={20}
                round={false} />
            </WhatsappShareButton>
            <FacebookShareButton
              url={shareUrl}
              title={title}>
              <FacebookIcon
                size={20}
                round={false} />
            </FacebookShareButton>
            <TwitterShareButton
              url={shareUrl}
              title={title}>
              <TwitterIcon
                size={20} />
            </TwitterShareButton>
            <LinkedinShareButton
              url={shareUrl}
              title={title}>
              <LinkedinIcon
                size={20} />
            </LinkedinShareButton>
          </Popover>
        )

        let bannedTypes = ['Hotel','Campo']
        if(!(parseInt(property.lat) in [0, undefined, null, '']) && !(parseInt(property.lat) in [0, undefined, null, '']) && !(bannedTypes.indexOf(property.property_type.name) != -1) ) {
          let mapClassName = (streetView != 'zero')? 'col-md-6 col-sm-6 map-left': 'col-md-12 map-center'
          mapsContent = (
            <div className='maps-container hidden-xs'>
              <div className={mapClassName}>
                <Maps lat={parseFloat(property.lat)} lng={parseFloat(property.lng)} prop={property} />
              </div>
              {(streetView != 'zero')? (
              <div className='col-md-6 col-sm-6 map-right'>
                <StreetViewMaps lat={parseFloat(property.lat)} lng={parseFloat(property.lng)} prop={property} checkresults={checkStreetViewStatus}/>
              </div>):''}
            </div>
          )
        }

        return(
          <div className='container-fluid property-detail'>
            {(this.state.showInfo) ? (
                <div className='show-caracteristics-modal'>
                  <Button className='btn-exit' onClick={this.toggle}>
                    <i className='fa fa-times' aria-hidden='true'></i>
                  </Button>
                  <h1>{t('Propiedad_Caracteristicas')}</h1>
                  <p>{property.observations}</p>
                </div>
              ) : (
                <div className={mainClass}>
                  <div className='modal-container'>
                    <HeaderInfo
                      property={property}
                      onChangePanelProfile={onChangePanelProfile}
                      originPath={originPath}
                      originOffice={originOffice}
                      />
                    <div className={sliderClass}>
                      <SliderDetail
                        icons={true}
                        property={property}
                        onChangePanelProfile={onChangePanelProfile} />
                    </div>
                  </div>
                  <div className='btns-container visible-xs'>
                    <Button className='btn-icon'>
                      <a onClick={(e) => e.stopPropagation()} target='_blank' href={`https://api.whatsapp.com/send?phone=54911${phone.replace(/\D+/g, '')}&text=${t('Consulta_WhatsApp_Interesado')}: ${property.property_type.name}  ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${dir}%0A${t('Consulta_WhatsApp_Codigo')}: ${property.property_code}`}>
                        <i className='fa fa-whatsapp fa-2x'></i>
                      </a>
                    </Button>
                    <Button className='btn-icon'>
                      <a href={telephone}><i className='fa fa-phone fa-2x'></i></a>
                    </Button>
                    <OverlayTrigger trigger='click' rootClose placement='top' overlay={popoverShare}>
                      <Button>
                        <i className='fa fa-share-alt fa-2x'></i>
                      </Button>
                    </OverlayTrigger>
                  </div>
                  <div className='caracteristics-container visible-xs'>
                    <h3> {dir} </h3>
                    <div className='neighbord-info'>
                      <i className='fa fa-map-marker'></i>
                      <h2 className='location'>{location}</h2>
                    </div>
                    <div className='bottom-info'>
                      <h2> {price}</h2>
                      <p> {t('Codigo')}: {property.property_code} </p>
                    </div>
                  </div>
                </div>
              )
            }
            <div className={mapClass}>
              { (infoType === 'map') ? (
                <div className='map-property-container'>
                  <div className='btn-view-map'>
                    <Button onClick={() =>onChangeInfoType('info')}> {t('Ver_Propiedad')} </Button>
                  </div>
                  <Maps lat={parseFloat(property.lat)} lng={parseFloat(property.lng)} prop={property} />
                </div>
                ) : ''
              }
              <div className='btns-container visible-xs'>
                <Button className='btn-icon'>
                  <a href={telephone}><i className='fa fa-phone fa-2x'></i></a>
                </Button>
                <Button className='btn-icon'>
                <a onClick={(e) => e.stopPropagation()} target='_blank' href={`https://api.whatsapp.com/send?phone=54911${phone.replace(/\D+/g, '')}&text=${t('Consulta_WhatsApp_Interesado')}: ${property.property_type.name} ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${dir}%0A${t('Consulta_WhatsApp_Codigo')}: ${property.property_code}`}>
                  <i className='fa fa-whatsapp fa-2x'></i>
                </a>
                </Button>
                <Button className='btn-icon'>
                  <i className='fa fa-envelope fa-2x'></i>
                </Button>
              </div>
            </div>
            <StickyMenu
              property={property}
              onChangePanelProfile={onChangePanelProfile} />
            <Description property={property} categories={officeCategories} terrainUses={terrainUses} />
            <ColumnsInfo
              property={property}
              categories={officeCategories}
              terrainUses={terrainUses}
              ubications={ubications}
              siblings={siblings}
              reloadProperties={(value) => this.handleChangeProperty(value)} />
            {mapsContent}
            {(neighborhoodDetail.length > 0) ? (
              <div className={('barrio-container') + ' ' + hideInfoContent + '' + hideNoNeighbord}>
                <Col md={6} xs={12}>
                  <h1 className='title-top hidden-xs'> Información acerca de {neighborhood} </h1>
                  <h1 className='title-top visible-xs'> Barrio de {neighborhood} </h1>
                  <div className='info-right hidden-xs'>
                    <i className='fa fa-map-marker'></i>
                    <h3>{neighborhood}</h3>
                  </div>
                  <div className='info hidden-xs'>
                    <p>
                      {neighborhoodDetail[0].description}
                    </p>
                  </div>
                  <hr className='hidden-xs'></hr>
                  {(neighborhoodDetail[0].images) ? (
                    <div className='col-xs-12 visible-xs'>
                      <div className='slider-container slider-detail'>
                        <SliderNeighborhood  neighborhood={neighborhoodDetail} />
                      </div>
                    </div>
                  ) : ''}
                  <div className='bottom-info'>
                    <Neighbordhood lat={parseFloat(neighborhoodDetail[0].location.lat)} lng={parseFloat(neighborhoodDetail[0].location.lng)} />
                  </div>
                </Col>
                {(neighborhoodDetail[0].images) ? (
                    <div className='col-md-6 hidden-xs'>
                      <div className='slider-container slider-detail'>
                        <SliderNeighborhood  neighborhood={neighborhoodDetail} />
                      </div>
                    </div>
                  ) : ''}
              </div> ) : ''
            }
            <div className={sliderClass}>
              <Col xs={12} className='form-right bottom-form visible-xs'>
                <FormContact property={property}/>
                <div className='contact-row'>
                  <span className='contact-whatsapp'>
                    <i className='fa fa-whatsapp'></i>
                    <a onClick={(e) => e.stopPropagation()} target='_blank' href={`https://api.whatsapp.com/send?phone=54911${phone.replace(/\D+/g, '')}&text=${t('Consulta_WhatsApp_Interesado')}: ${property.property_type.name} ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${dir}%0A${t('Consulta_WhatsApp_Codigo')}: ${property.property_code}`}>
                      <p>Whatsapp</p>
                    </a>
                  </span>
                  <span className='contact-phone'>
                    <i className='fa fa-phone'></i>
                    <a href={`tel:+5411${phone.replace('-', '')}`}><p>(5411) - {phone.replace('-', '')}</p></a>
                  </span>
                </div>
              </Col>
            </div>
            <div className='slider-container hidden-xs'>
              <div className='text-center title-slide'>{t('Propiedades_Similares')} </div>
              { (related.length > 3 && related.length != 3 ) ? <SliderHome properties={related} detail={true}/> : <SliderFixed properties={related} detail={true}/> }
            </div>
            <div className={('slider-properties-detail slider-container zone-properties similar visible-xs') + ' ' + hideInfoContent }>
              <h3>{t('Propiedades_Similares')} </h3>
              <div className='visible-xs box-slider'>
                <SliderHomeResponsive items={related}/>
              </div>
            </div>
          </div>
        )
      }
    }
  }
}

export default PropertyDetail



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/index.js